import {
  Image,
  PromoModalAction,
  PromoModalActions,
  PromoModalActionSecondary,
  PromoModalBody,
  PromoModalCloseButton,
  PromoModalContent,
  PromoModalDescription,
  PromoModalFooter,
  PromoModalMedia,
  PromoModalTitle,
} from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface ICpdLabelModalContent {
  imgUrl: string;
  title: string;
  description: React.ReactNode;
  actionText: string;
  onPrimaryAction: () => void;
  secondaryActionText?: string;
  onSecondaryAction?: () => void;
}

export const CpdLabelModalContent: React.FC<ICpdLabelModalContent> = ({
  imgUrl,
  title,
  description,
  actionText,
  onPrimaryAction,
  secondaryActionText,
  onSecondaryAction,
}) => {
  return (
    <PromoModalContent>
      <PromoModalMedia>
        <PromoModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
        <Image src={imgUrl} width="100%" height="auto" objectFit="cover" borderRadius="0" />
      </PromoModalMedia>
      <PromoModalBody>
        <PromoModalTitle>{title}</PromoModalTitle>
        <PromoModalDescription>{description}</PromoModalDescription>
      </PromoModalBody>
      <PromoModalFooter sticky={false}>
        <PromoModalActions>
          {secondaryActionText && (
            <PromoModalActionSecondary onClick={onSecondaryAction} size="M" theme="fill_white_primary">
              {secondaryActionText}
            </PromoModalActionSecondary>
          )}
          <PromoModalAction onClick={onPrimaryAction} size="M" theme="fill_primary">
            {actionText}
          </PromoModalAction>
        </PromoModalActions>
      </PromoModalFooter>
    </PromoModalContent>
  );
};
